const intToString = (value: number) => {
  if (value < 1000) {
    return value;
  } else if (value < 1000000) {
    return (value / 1000).toFixed((value / 1000) % 1 != 0 ? 1 : 0) + 'K';
  } else if (value < 1000000000) {
    return (value / 1000000).toFixed((value / 1000000) % 1 != 0 ? 1 : 0) + 'M';
  } else if (value < 1000000000000) {
    return (
      (value / 1000000000).toFixed((value / 1000000000) % 1 != 0 ? 1 : 0) + 'B'
    );
  } else {
    return (
      (value / 1000000000000).toFixed(
        (value / 1000000000000) % 1 != 0 ? 1 : 0,
      ) + 'T'
    );
  }
};

export default intToString;
